import { ChangeDetectionStrategy, Component, computed, OnInit, signal } from '@angular/core';
import { UserDb } from 'lib/cosmos/user/userDb.js';
import { nameHelper } from 'lib/helpers/name-helper.js';
import { ListItem } from 'lib/ui/list/index.js';
import { map } from 'rxjs';
import { TypeCoreComponent } from 'src/app/pages/type-routes/type-core.component.js';

type ClientWithRouterLink = UserDb.IUserItem & {
	readonly routerLink: string;
};

@Component({
	templateUrl: './chat.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class ChatComponent extends TypeCoreComponent implements OnInit {
	public readonly clients = signal<readonly ClientWithRouterLink[] | undefined>(undefined);

	public readonly clientListItems = computed<readonly ListItem<UserDb.IUserItem>[] | undefined>(() => {
		const clients = this.clients();

		if (!clients) {
			return undefined;
		}

		return clients.map<ListItem<UserDb.IUserItem>>((m) => {
			return {
				id: m.id,
				title: nameHelper.getUserName(m.email, m.firstName, m.lastName),
				subtitle: m.latestChatMessageWithTrainer?.message,
				avatar: m.avatar,
				routerLink: this.dependencies.navigateService
					.actionRoute((routes) => routes.chatRoutes.conversation.children.view, m.id)
					.getUrl(),
				fromNowDate: m.latestChatMessageWithTrainer?.created,
				data: m
			};
		});
	});

	constructor() {
		super();

		this.dataInit = () => {
			this.initClients();
		};
	}

	private initClients(): void {
		super.subscribeToObservable(
			this.dependencies.httpService
				.get<readonly UserDb.IUserItem[]>((builder) =>
					builder.withCustomApiRoute('user', 'listClients').build()
				)
				.pipe(
					map((response) => {
						this.clients.set(
							response.data
								.map((m) => ({
									...m,
									routerLink: this.dependencies.navigateService
										.actionRoute((routes) => routes.chatRoutes.conversation.children.view, m.id)
										.getUrl()
								}))
								.toSorted((a, b) => {
									const aLatestMessage = a.latestChatMessageWithTrainer;
									const bLatestMessage = b.latestChatMessageWithTrainer;

									if (!aLatestMessage || !bLatestMessage) {
										return 1;
									}

									return (
										new Date(bLatestMessage.created).getTime() -
										new Date(aLatestMessage.created).getTime()
									);
								})
						);
					})
				)
		);
	}
}
